import { render } from "./OptionalDataRefObjCom.vue?vue&type=template&id=431e8706"
import script from "./OptionalDataRefObjCom.vue?vue&type=script&lang=js"
export * from "./OptionalDataRefObjCom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__